"use no memo";

import React from 'react';
import { useSpring, animated } from 'react-spring';
import classNames from 'classnames';

type SlideUpInProps = {
  children?: React.ReactNode;
  className?: string | string[];
  delay?: number;
  maxHeight?: string | number;
  transformFrom?: string;
  transformTo?: string;
};

export const SlideUpIn: React.FunctionComponent<SlideUpInProps> = ({
  children,
  className,
  delay,
  transformFrom = 'translateY(100%)',
  transformTo = 'translateY(0)',
  maxHeight,
}) => {
  const { transform } = useSpring<{ transform: string }>({
    transform: transformTo,
    from: { transform: transformFrom },
    config: { tension: 400, friction: 35 },
    delay,
  });

  return (
    <animated.div
      style={{
        transform,
        height: 'inherit',
        transition: `transform ease-out 0.08s`,
        maxHeight,
      }}
      className={classNames(className)}
    >
      {children}
    </animated.div>
  );
};
